import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    mappings: [],
    stepperModel: 1,

    fileInspectorDone: false,
    columnMapperDone: false,
    uploaderDone: false,
    uploaderKey: 'uploader',

    // Component keys so they can be re-created from scratch
    fileInspectorKey: 'fileInspector',
    columnMapperKey: 'columnMapper',
    resultsKey: 'results',

    // These must be ordered from strictly to loose, i.e. email before string
    rawMappingTable: [
        {
            raw: 'Date',
            variableTypes: ['date']
        },
        {
            raw: 'Phone',
            variableTypes: ['phone', 'keyword']
        },
        {
            raw: 'Integer',
            variableTypes: ['radio', 'checkbox', 'number']
        },
        {
            raw: 'Numeric',
            variableTypes: ['number', 'keyword'],
        },
        {
            raw: 'Email',
            variableTypes: ['email', 'keyword'],
        },
        {
            raw: 'Locale',
            variableTypes: ['locale', 'keyword']
        },
        {
            raw: 'ZipCode',
            variableTypes: ['keyword','number'],
        },
        {
            raw: 'String',
            variableTypes: ['text', 'keyword'],
        },
    ]
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

